import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BRAND, fattahProjectTitle } from '@/config/brand';
import { resolveRoutePageTitle } from '@/config/routePageTitles';
import { getModuleEntryByErpModule } from '@/config/moduleEntries';
import { useActiveModule } from '@/hooks/useActiveModule';
import { useAppSelector } from '@/hooks/useAppSelector';

/** Browser tab title: Fattah + module + page when in workspace. */
export function useWorkspaceTitle() {
  const user = useAppSelector((s) => s.auth.user);
  const activeModule = useActiveModule();
  const location = useLocation();

  useEffect(() => {
    if (!user) {
      document.title = BRAND.name;
      return;
    }
    if (user.masterAdmin) {
      document.title = fattahProjectTitle('Master Admin');
      return;
    }
    const pageTitle = resolveRoutePageTitle(location.pathname);
    const projectLabel = activeModule
      ? getModuleEntryByErpModule(activeModule)?.label ?? activeModule
      : null;
    if (projectLabel && pageTitle) {
      document.title = fattahProjectTitle(`${pageTitle} · ${projectLabel}`);
      return;
    }
    if (projectLabel) {
      document.title = fattahProjectTitle(projectLabel);
      return;
    }
    const org = user.organizationName?.trim();
    document.title = org ? `${org} · ${BRAND.name}` : BRAND.name;
  }, [user?.masterAdmin, user?.organizationName, activeModule, location.pathname]);
}
